import {
  Layers,
  LayoutGrid,
  Ruler,
  PaintRoller,
  Paintbrush,
  Home,
  Building2,
  Trash2,
  Sparkles,
  Hammer,
  Construction,
  Truck,
  Shovel,
  TreePine,
  Recycle,
  LucideIcon,
} from "lucide-react";

export interface ServiceItem {
  slug: string;
  icon: LucideIcon;
}

export const drywallServices: ServiceItem[] = [
  { slug: "insulation", icon: Layers },
  { slug: "sheetrock", icon: LayoutGrid },
  { slug: "finishing", icon: Ruler },
  { slug: "texture", icon: PaintRoller },
  { slug: "painting", icon: Paintbrush },
  { slug: "residential", icon: Home },
  { slug: "commercial", icon: Building2 },
];

export const r3Services: ServiceItem[] = [
  { slug: "junk_removal", icon: Trash2 },
  { slug: "property_cleanup", icon: Sparkles },
  { slug: "concrete_breaking", icon: Hammer },
  { slug: "light_demolition", icon: Construction },
  { slug: "dirt_delivery", icon: Truck },
  { slug: "dirt_work", icon: Shovel },
  { slug: "tree_services", icon: TreePine },
  { slug: "trash_haul", icon: Recycle },
];

export interface GalleryItem {
  img?: string;
  cat: string;
  comingSoon?: boolean;
}

export const GALLERY_CATS = [
  "sheetrock",
  "finishing",
  "texture",
  "insulation",
  "painting",
  "residential",
  "commercial",
  "r3services",
];

// Placeholder imagery only — swap `img` values for real R3Stan project photos.
// Tiles with `comingSoon: true` intentionally show an empty placeholder until
// real photos for that category exist. Never present stock photos as real work.
export const galleryItems: GalleryItem[] = [
  {
    img: "https://images.pexels.com/photos/11427055/pexels-photo-11427055.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cat: "sheetrock",
  },
  {
    img: "https://images.pexels.com/photos/6474349/pexels-photo-6474349.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cat: "finishing",
  },
  { cat: "texture", comingSoon: true },
  { cat: "insulation", comingSoon: true },
  { cat: "painting", comingSoon: true },
  {
    img: "https://images.unsplash.com/photo-1587582423116-ec07293f0395?q=80&w=1200&auto=format&fit=crop",
    cat: "residential",
  },
  {
    img: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?q=80&w=1200&auto=format&fit=crop",
    cat: "residential",
  },
  {
    img: "https://images.pexels.com/photos/30580640/pexels-photo-30580640.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cat: "commercial",
  },
  {
    img: "https://images.pexels.com/photos/7598368/pexels-photo-7598368.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cat: "residential",
  },
  {
    img: "https://images.unsplash.com/photo-1616551569669-b60598758c4f?q=80&w=1200&auto=format&fit=crop",
    cat: "r3services",
  },
];

export interface R3EquipmentItem {
  slug: string;
  img?: string;
}

// Placeholder slots for future R3 Services equipment/project photos.
export const r3Equipment: R3EquipmentItem[] = [
  { slug: "bobcat" },
  {
    slug: "dirtWork",
    img: "https://images.unsplash.com/photo-1616551569669-b60598758c4f?q=80&w=1200&auto=format&fit=crop",
  },
  { slug: "cleanup" },
  { slug: "junk" },
  {
    slug: "concrete",
    img: "https://images.unsplash.com/photo-1599732596061-1f381074f115?q=80&w=1200&auto=format&fit=crop",
  },
  { slug: "demolition" },
  { slug: "hauling" },
];

export const heroImg =
  "https://images.unsplash.com/photo-1587582423116-ec07293f0395?q=80&w=2200&auto=format&fit=crop";

export const aboutImg =
  "https://images.pexels.com/photos/11427055/pexels-photo-11427055.jpeg?auto=compress&cs=tinysrgb&w=1100";

export const r3Imgs = [
  "https://images.unsplash.com/photo-1616551569669-b60598758c4f?q=80&w=1400&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1599732596061-1f381074f115?q=80&w=1400&auto=format&fit=crop",
];
